import Filic from '@/Filic.js';
import File from '@/File';
import Directory from '@/Directory';
import Entity from '@/Entity';
import { EntityTypes } from '@/types/Filic';


export {
    File,
    Directory,
    Entity,
    EntityTypes
}

export default Filic;
